export default __webpack_public_path__ + "static/media/DECDOM2024.c18c82c9.jpg";